import CircularProgress from "@material-ui/core/CircularProgress";
import React from "react";
import Loader from "../loader/Loader";
import "./index.scss";

const MyButton = ({
  className,
  buttonTextStyle,
  type,
  disabled,
  sendData,
  onClick,
  content,
  symbol,
  loading,
  isChangeWidth,
  ...props
}) => {
  if (loading)
    return (
      <div className="w-100 h-100 d-flex justify-content-center align-items-center">
        <Loader />
      </div>
    );

  return (
    <button
      disabled={disabled}
      className={
        disabled === true
          ? "disabled"
          : type === "secondary"
            ? "secondary-button"
            : type === "primary"
              ? "primary-button"
              : type === "notpaid"
                ? "next-review-button"
                : "primary-button"
      }
      style={{ maxWidth: isChangeWidth ? '103px' : '', minWidth: isChangeWidth ? '100px' : "", textAlign: isChangeWidth ? "left" : "center" }}
      onClick={onClick}
      {...props}
      type="button"
    >
      <p className="button-text" style={buttonTextStyle}>
        {symbol}
        {content}
      </p>
    </button>
  );
};

export default MyButton;
